module.exports = "<p>Ring Central Authentication</p>\n"